import { createIcon } from './icon';

export const ArrowLeft = createIcon(
  <svg
    width="13"
    height="10"
    viewBox="0 0 13 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.1795 9.02781C4.85338 9.36558 4.31367 9.37031 3.98168 9.03832L0.293045 5.34969C-0.0974793 4.95916 -0.09748 4.326 0.293044 3.93547L3.98168 0.246837C4.31367 -0.085157 4.85338 -0.0804241 5.1795 0.257343C5.49763 0.586833 5.49304 1.11048 5.16918 1.43434L2.79427 3.80924H12.0859C12.5462 3.80924 12.9193 4.18234 12.9193 4.64258C12.9193 5.10282 12.5462 5.47591 12.0859 5.47591H2.79427L5.16918 7.85082C5.49304 8.17468 5.49763 8.69832 5.1795 9.02781Z"
      fill="currentColor"
    />
  </svg>,
  'ArrowLeft'
);
